import axios from "axios";
import graph from "../services/graph";

//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getAll(accessToken,skip,case_id) {
    try {
      console.log(accessToken);
      return axios.get("https://app-psod.cratis.cloud/api/email", {
        params: {
          token: accessToken,
          skip,
          case_id
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getById(accessToken, id) {
    try {
      return axios.get("https://app-psod.cratis.cloud/api/email/" + id, {
        params: {
          token: accessToken,
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  saveEmail(accessToken, id, groupId, sid,html_to_upload) {
    try {
      return axios.post("https://app-psod.cratis.cloud/api/email/"+id+"/save-to-pdf", {
        params: {
          token: accessToken,
          groupId,
          sid,
          html_to_upload
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  saveEmailAttachment(accessToken, id, groupId, sid,file_to_upload) {
    try {
      return axios.post("https://app-psod.cratis.cloud/api/email/"+id+"/save-attachment", {
        params: {
          token: accessToken,
          groupId,
          sid,
          file_to_upload
        },
        credentials: true,
      });
    } catch {
      console.log("Failed attempt at group by id.");
    }
  },
  

  
};
